import React from 'react';
import { CookieBannerHeaderStyles } from './CookieBanner.styles';
import { CVENT_LINKS } from '../../constants/constants';

export function getCookieLinks(
    cookieLinks,
    showSplashPrivacyPolicy,
    showSplashCookieList,
    showCompanyPrivacyPolicy,
    showCompanyCookiePolicy,
) {
    const LinkElement = ({ url, text }) => (
        <a
            key={text?.toLowerCase()?.replace(/\s+/g, '-')}
            href={url}
            target="_blank"
            style={CookieBannerHeaderStyles.link}
        >
            {text}
        </a>
    );

    const links = [
        showSplashPrivacyPolicy && { ...cookieLinks?.splashPrivacyPolicy },
        showSplashCookieList && { ...cookieLinks?.splashCookieList },
        showCompanyPrivacyPolicy && { ...cookieLinks?.privacyPolicy },
        showCompanyCookiePolicy && { ...cookieLinks?.cookiePolicy },
    ].filter(Boolean);

    const linkElements = links.map((link) => <LinkElement {...link} />);

    return (
        <div style={CookieBannerHeaderStyles.links}>
            {linkElements.length < 1 ? null : linkElements.reduce((prev, curr) => [prev, ' | ', curr])}
        </div>
    );
}

// Transforms the data from the API to the format expected by the CookieBanner component
export function getBannerProps(data) {
    const {
        cookieBannerHeadline,
        cookieBannerText,
        cookieCategoriesAccordionHeadline,
        declineNonEssentialBtnLabel,
        acceptAllBtnLabel,
        confirmChoicesBtnLabel,
        strictlyNecessaryCategoryLabel,
        strictlyNecessaryCategoryDescription,
        performanceCategoryLabel,
        performanceCategoryDescription,
        functionalCategoryLabel,
        functionalCategoryDescription,
        marketingCategoryLabel,
        marketingCategoryDescription,
        displaySplashPrivacyPolicy,
        splashPrivacyPolicyLabel,
        displaySplashCookiePolicy,
        splashCookiePolicyLabel,
        displayCompanyPrivacyPolicy,
        companyPrivacyPolicyUrl,
        companyPrivacyPolicyLabel,
        displayCompanyCookiePolicy,
        companyCookiePolicyUrl,
        companyCookiePolicyLabel,
        canDisableNonEssentialCookies,
        canDisableCookiesByCategory,
    } = data || {};

    const cookieLinks = {
        splashPrivacyPolicy: {
            text: splashPrivacyPolicyLabel,
            url: CVENT_LINKS.PRIVACY_POLICY,
        },
        splashCookieList: {
            text: splashCookiePolicyLabel,
            url: CVENT_LINKS.COOKIE_POLICY,
        },
        privacyPolicy: {
            url: companyPrivacyPolicyUrl,
            text: companyPrivacyPolicyLabel,
        },
        cookiePolicy: {
            url: companyCookiePolicyUrl,
            text: companyCookiePolicyLabel,
        },
    };

    const customBannerText = {
        title: cookieBannerHeadline,
        description: cookieBannerText,
        chooseConsentSettings: cookieCategoriesAccordionHeadline,
        declineNonEssentialButton: declineNonEssentialBtnLabel,
        acceptAllButton: acceptAllBtnLabel,
        confirmSelectionButton: confirmChoicesBtnLabel,
        necessaryHeader: strictlyNecessaryCategoryLabel,
        necessaryDescription: strictlyNecessaryCategoryDescription,
        performanceHeader: performanceCategoryLabel,
        performanceDescription: performanceCategoryDescription,
        functionalityHeader: functionalCategoryLabel,
        functionalityDescription: functionalCategoryDescription,
        marketingHeader: marketingCategoryLabel,
        marketingDescription: marketingCategoryDescription,
    };

    return {
        customBannerText,
        cookieLinks,
        showSplashPrivacyPolicy: displaySplashPrivacyPolicy,
        showSplashCookieList: displaySplashCookiePolicy,
        showCompanyPrivacyPolicy: displayCompanyPrivacyPolicy,
        showCompanyCookiePolicy: displayCompanyCookiePolicy,
        showDeclineNonEssentialButton: canDisableNonEssentialCookies,
        showConsentSettings: canDisableCookiesByCategory,
    };
}
